import React, { useState, useEffect } from 'react';
import { api } from '../services/api';

interface Order {
  id: number;
  supplier_name: string;
  order_date: string;
  delivery_date: string;
  total_amount: number;
  status: string;
}

const Orders: React.FC = () => {
  const [orders, setOrders] = useState<Order[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const response = await api.get('/orders/');
      setOrders(response.data);
    } catch (error) {
      console.error('Error fetching orders:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading-message">Chargement des commandes...</div>;
  }

  return (
    <div className="orders-container">
      <div className="page-header">
        <h2>🛒 Gestion des Commandes</h2>
      </div>
      
      {orders.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">🛒</div>
          <p className="empty-message">Aucune commande disponible</p>
        </div>
      ) : (
        <>
          {/* Desktop: Table View */}
          <div className="orders-table-view">
            <div className="table-wrapper">
              <table className="stock-table">
                <thead>
                  <tr>
                    <th>Commande</th>
                    <th>Fournisseur</th>
                    <th>Date Commande</th>
                    <th>Date Livraison</th>
                    <th>Montant Total</th>
                    <th>Statut</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map(order => (
                    <tr key={order.id}>
                      <td>
                        <span className="order-id-badge">#{order.id}</span>
                      </td>
                      <td><strong>{order.supplier_name}</strong></td>
                      <td>{new Date(order.order_date).toLocaleDateString('fr-FR')}</td>
                      <td>{new Date(order.delivery_date).toLocaleDateString('fr-FR')}</td>
                      <td><strong className="price-value">{order.total_amount.toLocaleString('fr-FR')} CFA</strong></td>
                      <td>
                        <span className={`status-badge ${
                          order.status === 'delivered' ? 'success' : 
                          order.status === 'pending' ? 'warning' : 'danger'
                        }`}>
                          {order.status === 'delivered' ? '✅ Livré' : 
                           order.status === 'pending' ? '⏳ En attente' : '❌ Annulé'}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Mobile: Cards View */}
          <div className="orders-cards-view">
            {orders.map(order => (
              <div key={order.id} className="order-card">
                <div className="order-card-header">
                  <div className="order-title-section">
                    <span className="order-id-badge">#{order.id}</span>
                    <h3 className="order-supplier">{order.supplier_name}</h3>
                  </div>
                  <span className={`status-badge ${
                    order.status === 'delivered' ? 'success' : 
                    order.status === 'pending' ? 'warning' : 'danger'
                  }`}>
                    {order.status === 'delivered' ? '✅ Livré' : 
                     order.status === 'pending' ? '⏳ En attente' : '❌ Annulé'}
                  </span>
                </div>
                
                <div className="order-card-body">
                  <div className="order-info-grid">
                    <div className="order-info-item">
                      <span className="info-label">Date de commande</span>
                      <span className="info-value">{new Date(order.order_date).toLocaleDateString('fr-FR')}</span>
                    </div>
                    <div className="order-info-item">
                      <span className="info-label">Date de livraison</span>
                      <span className="info-value">{new Date(order.delivery_date).toLocaleDateString('fr-FR')}</span>
                    </div>
                    <div className="order-info-item full-width">
                      <span className="info-label">Montant total</span>
                      <span className="info-value price-value">{order.total_amount.toLocaleString('fr-FR')} CFA</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Orders;